import Router from "./pages/shared/router";

function App() {
  return <Router />;
}

export default App;
